(() => {
  'use strict';

  if (customElements.get('fullerton-suggested-products')) {
    return;
  }


  class FullertonSuggestedProducts extends HTMLElement {

    constructor() {

      super();

      this.dialog = null;

      this.dialogObserver = null;

      this.handleClick =
        this.handleClick.bind(this);

      this.handleChange =
        this.handleChange.bind(this);

      this.handleDialogMutation =
        this.handleDialogMutation.bind(this);
    }


    connectedCallback() {

      this.limit = Math.max(
        1,
        parseInt(
          this.dataset.limit || '4',
          10
        )
      );


      this.addEventListener(
        'click',
        this.handleClick
      );


      this.addEventListener(
        'change',
        this.handleChange
      );


      this.dialog =
        this.closest('dialog');


      if (this.dialog) {

        this.dialogObserver =
          new MutationObserver(
            this.handleDialogMutation
          );


        this.dialogObserver.observe(
          this.dialog,
          {
            attributes: true,
            attributeFilter: ['open']
          }
        );


        if (
          this.dialog.hasAttribute('open')
        ) {

          this.rotateProducts();
        }

      } else {

        this.rotateProducts();

      }

    }


    disconnectedCallback() {

      this.removeEventListener(
        'click',
        this.handleClick
      );


      this.removeEventListener(
        'change',
        this.handleChange
      );


      if (this.dialogObserver) {

        this.dialogObserver.disconnect();

      }

    }


    /*
    =========================================================
    CUANDO SE ABRE EL CARRITO
    =========================================================
    */

    handleDialogMutation() {

      if (
        this.dialog &&
        this.dialog.hasAttribute('open')
      ) {

        this.rotateProducts();

      }

    }


    /*
    =========================================================
    TARJETAS
    =========================================================
    */

    getCards() {

      return Array.from(
        this.querySelectorAll(
          '[data-fs-card]'
        )
      );

    }


    /*
    =========================================================
    ROTACIÓN
    =========================================================
    */

    rotateProducts() {

      const cards =
        this.getCards();


      if (!cards.length) {

        this.hidden = true;

        return;

      }


      this.hidden = false;


      cards.forEach(
        (card) => {

          card.hidden = true;

        }
      );


      /*
       * Si tenemos hasta 4 productos,
       * mostramos todos.
       */

      if (
        cards.length <= this.limit
      ) {

        cards.forEach(
          (card) => {

            card.hidden = false;

          }
        );

        return;

      }


      /*
       * Firma de la lista actual.
       */

      const signature =
        cards
          .map(
            (card) =>
              card.dataset.variantId || ''
          )
          .join('-');


      const storageKey =
        `fullerton_suggested_offset_${signature}`;


      let offset = null;


      try {

        const storedOffset =
          window.sessionStorage.getItem(
            storageKey
          );


        if (
          storedOffset !== null
        ) {

          offset =
            parseInt(
              storedOffset,
              10
            );

        }

      } catch (error) {

        offset = null;

      }


      /*
       * Primera apertura:
       * empezamos en una posición aleatoria.
       */

      if (
        offset === null ||
        Number.isNaN(offset) ||
        offset >= cards.length
      ) {

        offset =
          Math.floor(
            Math.random() *
            cards.length
          );

      }


      /*
       * Mostrar solamente el límite.
       */

      for (
        let index = 0;
        index < this.limit;
        index += 1
      ) {

        const cardIndex =
          (offset + index) %
          cards.length;


        cards[cardIndex].hidden =
          false;

      }


      /*
       * Próximo grupo.
       */

      const nextOffset =
        (offset + this.limit) %
        cards.length;


      try {

        window.sessionStorage.setItem(
          storageKey,
          String(nextOffset)
        );

      } catch (error) {

        /*
         * Si sessionStorage está bloqueado
         * simplemente no persistimos.
         */

      }

    }


    /*
    =========================================================
    CLICS
    =========================================================
    */

    handleClick(event) {

      const target =
        event.target instanceof Element
          ? event.target
          : null;


      if (!target) {
        return;
      }


      /*
       * BOTÓN MENOS
       */

      const minusButton =
        target.closest(
          '[data-fs-quantity-minus]'
        );


      if (
        minusButton &&
        this.contains(minusButton)
      ) {

        /*
         * MUY IMPORTANTE:
         * evitamos que este clic llegue a
         * cualquier controlador del carrito.
         */

        event.preventDefault();

        event.stopPropagation();


        const quantityWrapper =
          minusButton.closest(
            '[data-fs-quantity]'
          );


        this.changeQuantity(
          quantityWrapper,
          -1
        );


        return;

      }


      /*
       * BOTÓN MÁS
       */

      const plusButton =
        target.closest(
          '[data-fs-quantity-plus]'
        );


      if (
        plusButton &&
        this.contains(plusButton)
      ) {

        event.preventDefault();

        event.stopPropagation();


        const quantityWrapper =
          plusButton.closest(
            '[data-fs-quantity]'
          );


        this.changeQuantity(
          quantityWrapper,
          1
        );


        return;

      }


      /*
       * BOTÓN AGREGAR
       */

      const addButton =
        target.closest(
          '[data-fs-add]'
        );


      if (
        addButton &&
        this.contains(addButton)
      ) {

        event.preventDefault();

        event.stopPropagation();


        this.addProduct(
          addButton
        );


      }

    }


    /*
    =========================================================
    CAMBIO MANUAL DEL INPUT
    =========================================================
    */

    handleChange(event) {

      const target =
        event.target;


      if (
        !(target instanceof HTMLInputElement)
      ) {

        return;

      }


      if (
        !target.matches(
          '[data-fs-quantity-input]'
        )
      ) {

        return;

      }


      /*
       * Cambiar el número NO agrega productos.
       * Solamente validamos el valor.
       */

      this.normalizeQuantity(
        target
      );

    }


    /*
    =========================================================
    CAMBIAR CANTIDAD
    =========================================================
    */

    changeQuantity(
      quantityWrapper,
      direction
    ) {

      if (!quantityWrapper) {
        return;
      }


      const input =
        quantityWrapper.querySelector(
          '[data-fs-quantity-input]'
        );


      if (
        !(input instanceof HTMLInputElement)
      ) {

        return;

      }


      const currentValue =
        this.normalizeQuantity(
          input
        );


      const minimum =
        this.getMinimum(
          input
        );


      const maximum =
        this.getMaximum(
          input
        );


      const step =
        this.getStep(
          input
        );


      let nextValue =
        currentValue;


      if (direction > 0) {

        nextValue =
          currentValue + step;


        if (
          Number.isFinite(maximum)
        ) {

          nextValue =
            Math.min(
              nextValue,
              maximum
            );

        }

      } else {

        nextValue =
          Math.max(
            currentValue - step,
            minimum
          );

      }


      input.value =
        String(nextValue);

    }


    /*
    =========================================================
    VALIDAR CANTIDAD
    =========================================================
    */

    normalizeQuantity(input) {

      const minimum =
        this.getMinimum(
          input
        );


      const maximum =
        this.getMaximum(
          input
        );


      let value =
        parseInt(
          input.value,
          10
        );


      if (
        Number.isNaN(value)
      ) {

        value = minimum;

      }


      value =
        Math.max(
          value,
          minimum
        );


      if (
        Number.isFinite(maximum)
      ) {

        value =
          Math.min(
            value,
            maximum
          );

      }


      input.value =
        String(value);


      return value;

    }


    getMinimum(input) {

      const value =
        parseInt(
          input.min,
          10
        );


      return (
        Number.isFinite(value) &&
        value > 0
      )
        ? value
        : 1;

    }


    getMaximum(input) {

      if (!input.max) {

        return Infinity;

      }


      const value =
        parseInt(
          input.max,
          10
        );


      return Number.isFinite(value)
        ? value
        : Infinity;

    }


    getStep(input) {

      const value =
        parseInt(
          input.step,
          10
        );


      return (
        Number.isFinite(value) &&
        value > 0
      )
        ? value
        : 1;

    }


    /*
    =========================================================
    AGREGAR PRODUCTO
    =========================================================
    */

    async addProduct(button) {

      if (button.disabled) {
        return;
      }


      const card =
        button.closest(
          '[data-fs-card]'
        );


      if (!card) {
        return;
      }


      const input =
        card.querySelector(
          '[data-fs-quantity-input]'
        );


      if (
        !(input instanceof HTMLInputElement)
      ) {

        return;

      }


      const quantity =
        this.normalizeQuantity(
          input
        );


      const variantId =
        parseInt(
          button.dataset.variantId,
          10
        );


      if (
        !Number.isFinite(variantId)
      ) {

        this.showError(
          card,
          'No se encontró la variante del producto.'
        );

        return;

      }


      const originalText =
        button.textContent;


      button.disabled = true;

      button.textContent =
        'Agregando...';


      this.clearStatus(
        card
      );


      try {

        /*
         * Obtenemos el ID real de la sección
         * que utiliza este carrito.
         */

        const cartItemsComponent =
          document.querySelector(
            'cart-drawer-component cart-items-component'
          );


        const sectionId =
          cartItemsComponent
            ?.dataset
            ?.sectionId ||
          '';


        /*
         * Ruta de Shopify respetando idiomas/subcarpetas.
         */

        let root =
          window.Shopify
            ?.routes
            ?.root ||
          '/';


        if (
          !root.endsWith('/')
        ) {

          root += '/';

        }


        const addUrl =
          `${root}cart/add.js`;


        /*
         * Solo ESTE punto modifica el carrito.
         */

        const payload = {

          items: [
            {
              id: variantId,
              quantity: quantity
            }
          ],

          sections_url:
            window.location.pathname

        };


        /*
         * Pedimos a Shopify que también nos
         * devuelva la sección actualizada.
         */

        if (sectionId) {

          payload.sections =
            sectionId;

        }


        const response =
          await fetch(
            addUrl,
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json',

                'X-Requested-With':
                  'XMLHttpRequest'
              },

              credentials:
                'same-origin',

              body:
                JSON.stringify(
                  payload
                )
            }
          );


        let result;


        try {

          result =
            await response.json();

        } catch (error) {

          throw new Error(
            'Shopify devolvió una respuesta inválida.'
          );

        }


        if (
          !response.ok ||
          result?.status
        ) {

          throw new Error(
            result?.description ||
            result?.message ||
            'No fue posible agregar el producto.'
          );

        }


        /*
         * Actualizamos solamente el contenido
         * del carrito. NO recargamos la página.
         */

        const sectionHtml =
          sectionId
            ? result
                ?.sections
                ?.[sectionId]
            : null;


        if (
          sectionHtml
        ) {

          this.replaceCartSection(
            sectionHtml
          );

        } else {

          await this.refreshCartSection(
            sectionId
          );

        }


      } catch (error) {

        console.error(
          '[Fullerton suggested products]',
          error
        );


        if (
          card.isConnected
        ) {

          this.showError(
            card,
            error?.message ||
            'No fue posible agregar el producto.'
          );

        }


        if (
          button.isConnected
        ) {

          button.disabled = false;

          button.textContent =
            originalText;

        }

      }

    }


    /*
    =========================================================
    ACTUALIZAR CARRITO CON HTML DEVUELTO POR SHOPIFY
    =========================================================
    */

    replaceCartSection(sectionHtml) {

      const parser =
        new DOMParser();


      const documentResponse =
        parser.parseFromString(
          sectionHtml,
          'text/html'
        );


      const newCartItems =
        documentResponse.querySelector(
          'cart-items-component'
        );


      const currentCartItems =
        document.querySelector(
          'cart-drawer-component cart-items-component'
        );


      if (
        !newCartItems ||
        !currentCartItems
      ) {

        throw new Error(
          'No fue posible actualizar visualmente el carrito.'
        );

      }


      /*
       * Conservamos el diálogo abierto.
       * Solo sustituimos el componente de contenido.
       */

      const replacement =
        document.importNode(
          newCartItems,
          true
        );


      currentCartItems.replaceWith(
        replacement
      );


      /*
       * Actualizar los indicadores numéricos
       * del carrito que estén fuera del contenido.
       */

      this.updateCartBubbles(
        documentResponse
      );

    }


    /*
    =========================================================
    FALLBACK:
    PEDIR LA SECCIÓN ACTUALIZADA A SHOPIFY
    =========================================================
    */

    async refreshCartSection(
      sectionId
    ) {

      if (!sectionId) {

        /*
         * Este caso debería ser excepcional.
         */

        window.location.reload();

        return;

      }


      const sectionUrl =
        new URL(
          window.location.href
        );


      sectionUrl.searchParams.set(
        'section_id',
        sectionId
      );


      const response =
        await fetch(
          sectionUrl.toString(),
          {
            credentials:
              'same-origin',

            cache:
              'no-store',

            headers: {
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        );


      if (!response.ok) {

        throw new Error(
          'No fue posible actualizar el carrito.'
        );

      }


      const html =
        await response.text();


      this.replaceCartSection(
        html
      );

    }


    /*
    =========================================================
    ACTUALIZAR CONTADORES
    =========================================================
    */

    updateCartBubbles(
      documentResponse
    ) {

      const currentDrawer =
        document.querySelector(
          'cart-drawer-component'
        );


      const newDrawer =
        documentResponse.querySelector(
          'cart-drawer-component'
        );


      if (
        !currentDrawer ||
        !newDrawer
      ) {

        return;

      }


      const currentBubbles =
        currentDrawer.querySelectorAll(
          '.cart-bubble'
        );


      const newBubbles =
        newDrawer.querySelectorAll(
          '.cart-bubble'
        );


      currentBubbles.forEach(
        (bubble, index) => {

          const newBubble =
            newBubbles[index];


          if (!newBubble) {
            return;
          }


          bubble.innerHTML =
            newBubble.innerHTML;


          for (
            const attribute
            of Array.from(
              bubble.attributes
            )
          ) {

            if (
              attribute.name ===
              'class'
            ) {

              continue;

            }


            bubble.removeAttribute(
              attribute.name
            );

          }


          for (
            const attribute
            of Array.from(
              newBubble.attributes
            )
          ) {

            if (
              attribute.name ===
              'class'
            ) {

              continue;

            }


            bubble.setAttribute(
              attribute.name,
              attribute.value
            );

          }

        }
      );

    }


    /*
    =========================================================
    ESTADOS / ERRORES
    =========================================================
    */

    clearStatus(card) {

      const status =
        card.querySelector(
          '[data-fs-status]'
        );


      if (!status) {
        return;
      }


      status.textContent =
        '';


      status.removeAttribute(
        'data-error'
      );

    }


    showError(
      card,
      message
    ) {

      const status =
        card.querySelector(
          '[data-fs-status]'
        );


      if (!status) {
        return;
      }


      status.dataset.error =
        'true';


      status.textContent =
        message;

    }

  }


  customElements.define(
    'fullerton-suggested-products',
    FullertonSuggestedProducts
  );

})();
